<template>
  <div>
    <div v-if="!loading" style="height: 200px; overflow-y: scroll;">
      <b-table small hover :fields="tablefields" :items="data" responsive="sm" primary-key="time">
        <template #cell(index)="data">{{ data.index + 1 }}</template>
        <template slot="bottom-row">
          <td>&nbsp;</td>
          <td align=center><b>Total</b></td>
          <td><b>{{this.t_rx_bytes.toFixed(2) }}</b></td>
          <td><b>{{this.t_tx_bytes.toFixed(2) }}</b></td>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    'interface': '',
    deviceID: '',
    device: {
      type: String,
      default: ''
    },
    period: {
      type: String,
      default: 'D'
    },
  },
  data() {
    return {
      data: '',
      loading: true,
      tablefields: [
        { key: 'index', label: '#' },
        { key: 'time', label: "Time" },
        { key: 'rx', label: "RX" },
        { key: 'tx', label: "TX" },
      ],
      t_tx_bytes: 0,
      t_rx_bytes: 0,
    }
  },
  methods: {
    getData() {
      this.loading = true;
      let uri = `/api/devices/${this.deviceID}/data?type=traffic&interface=${this.interface}&device=${this.device}&period=${this.period}`;

      axios.get(uri)
        .then(response => {
          this.data = response.data.data;
          if (this.data) {;
            this.loading = false;
            this.data.forEach(element => {
              this.t_rx_bytes += parseFloat(element.rx);
              this.t_tx_bytes += parseFloat(element.tx);
            });

          } else {
            console.log('NO DATA 2');
          }
        }).catch(error => {

          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data);
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);

        })

    },

  },

  mounted() {
    this.getData();
  },

}
</script>
